<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
<!--        <div v-if="$gate.isSysAdmin()">-->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<!-- main row for all icons  -->
			<div class="col-lg-12">
				<div class="card card-danger ">
					<div class="card-header">
						Partner
					</div>
					<div class="card-body overflow-auto">
						{{partner}}
					</div>
					<div class="card-footer">

					</div>
				</div>
			</div>

			<div class="col-lg-12">
				<div class="card card-danger ">
					<div class="card-header">
						Drivers
					</div>
					<div class="card-body overflow-auto">
						<table class="table table-striped table-bordered table-hover">
							<thead>
								<tr>
									<th scope="col">Name</th>
									<th scope="col">Mobile</th>
									<th scope="col">Email</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="lead in drivers" :key="lead.id">
									<td>{{lead.lead_profile.name}}</td>
									<td>{{lead.lead_profile.mobile}}</td>
									<td>{{lead.lead_profile.email}}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="card-footer">
						<pagination :pagination="dpagination"
						 	@prev="getDrivers(dpagination.prevPageUrl)"
						  @next="getDrivers(dpagination.nextPageUrl)"
						></pagination>
					</div>
				</div>
			</div>

			<div class="col-lg-12">
				<div class="card card-danger ">
					<div class="card-header">
						Vehicles
					</div>
					<div class="card-body overflow-auto">
						<table class="table table-striped table-bordered table-hover">
							<thead>
								<tr>
									<th scope="col">Make</th>
									<th scope="col">Model</th>
									<th scope="col">Year</th>
									<th scope="col">Weight Capacity</th>
									<th scope="col">Status</th>
									<th scope="col">Notes</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="vehicle in vehicles">
									<td>{{vehicle.make}}</td>
									<td>{{vehicle.model}}</td>
									<td>{{vehicle.year}}</td>
									<td>{{vehicle.weight_capacity}}</td>
									<td>{{vehicle.status}}</td>
									<td>{{vehicle.notes}}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="card-footer">
						<pagination :pagination="vpagination"
						 	@prev="getVehicles(vpagination.prevPageUrl)"
						  @next="getVehicles(vpagination.nextPageUrl)"
						></pagination>
					</div>
				</div>
			</div>
<!-- row end -->
    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
<!--        </div>-->
<!--        <div v-if="!$gate.isSysAdmin()">-->
<!--             <access-denied></access-denied>-->
<!--        </div>-->
    </div>
</template>

<script>
		 import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {pagination:Pagination},

        created(){
        	this.getPartner();
        	this.getDrivers();
        	this.getVehicles();
        },

        data(){
        	return {
        		partner: {},
        		drivers: [],
        		vehicles: [],
        		dpagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         	  },
         	  vpagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         	  },
        	}
        },

        methods: {
        	getPartner(){
        		axios.post("/api/getDeliveryPartner", {id: this.$route.params.id})
        		.then(response => {
        			this.partner = response.data;
        		})
        	},

        	getDrivers(url="/api/getPartnerDrivers"){
        		axios.post(url, {dp: this.$route.params.id})
        		.then(response => {
        			this.drivers = response.data.data.data;
        			this.configDPagination(response.data.data);
        		})
        	},

        	getVehicles(url="/api/getPartnerVehicles"){
        		axios.post(url, {dp: this.$route.params.id})
        		.then(response => {
        			this.vehicles = response.data.data.data;
        			this.configVPagination(response.data.data);
        		})
        	},

        	configDPagination(data){
		    		this.dpagination.lastPage=data.lastPage;
		       	this.dpagination.currentPage=data.current_page;
		  	  	this.dpagination.total=data.total;
		      	this.dpagination.lastPageUrl=data.last_page_url;
		     		this.dpagination.nextPageUrl=data.next_page_url;
		     		this.dpagination.prevPageUrl=data.prev_page_url;
		   		 	this.dpagination.from=data.from;
		      	this.dpagination.to=data.to;
		  		},

    			configVPagination(data){
		    		this.vpagination.lastPage=data.lastPage;
		       	this.vpagination.currentPage=data.current_page;
		  	  	this.vpagination.total=data.total;
		      	this.vpagination.lastPageUrl=data.last_page_url;
		     		this.vpagination.nextPageUrl=data.next_page_url;
		     		this.vpagination.prevPageUrl=data.prev_page_url;
		   		 	this.vpagination.from=data.from;
		      	this.vpagination.to=data.to;
		  		},
        }
    }
</script>
